<template>
  <v-card>
    <v-card-title>
      <span :class="['headline indigo--text text--darken-2 ml-0']">Select client:</span>
      <v-spacer></v-spacer>
      <v-btn class="mt-n2 mr-n1" fab dark small color="pink" @click="addClient()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 350px" class="pa-2">
      <v-list-item-group v-model="model" active-class="border" color="indigo">
        <v-list-item v-for="(client, index) in clients" :key="index" class="v4">
          <v-list-item-content class="pa-0">
            <client-item-thin :client="client" :key="client.cid" @click="selectClient"></client-item-thin>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-card-text>
    <v-card-actions>
      <!-- <v-btn v-if="!inNewMode" color="red darken-1" text @click="obj.remove(obj.item)">Delete</v-btn> -->
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="selectClient">Select</v-btn>
      <v-btn color="green darken-1" text @click="obj.close()">Cancel</v-btn>
    </v-card-actions>
    <template>
      <v-row justify="center">
        <v-dialog v-model="showClient" scrollable persistent max-width="600px">
          <DialogClient :item="objClient" />
        </v-dialog>
      </v-row>
    </template>
  </v-card>
</template>

<script>
import { storeprops } from "@/store/helpers.js";
import ClientItemThin from "@/components/client/ClientItemThin";
//import ClientItem from "@/components/client/ClientItem";
import DialogClient from "@/components/dialogs/DialogClient";

export default {
  components: { ClientItemThin, DialogClient },
  props: {
    obj: Object
  },
  computed: {
    ...storeprops
  },
  data: () => {
    return {
      active: false,
      model: 1,
      showClient: false,
      objClient: {}
    };
  },
  methods: {
    selectClient() {
      let client = this.clients[this.model];
      this.obj.select(client);
    },
    addClient() {
      this.objClient = new objDataClient();
      this.objClient.canDelete = false;
      this.objClient.inNewMode = true;
      this.objClient.client = {};
      this.objClient.closeDialog = () => (this.showClient = false);
      this.objClient.updateClient = client2 => {
        this.$store.dispatch("createClient", client2);
        this.showClient = false;
      };
      this.showClient = true;
    }
  }
};

class objDataClient {
  client = null;
  canDelete = false;
  inNewMode = false;
  updateClient = null;
  deleteClient = null;
  closeDialog = null;
}
</script>

<style scoped>
.border {
  border: 2px dashed orange;
}
.v4 {
  min-height: auto;
}
.v5 {
  padding: 0px;
  margin: 0px;
}
</style>